import React, { useState } from 'react'
import { Button } from 'reactstrap'
import { animated, useTransition } from 'react-spring'

interface DisclosureProps {
  /**
   * Button label for toggling content
   */
  label: string
  /**
   * If user wants to show a different label to close, e.g., when the content is visible
   * @default label
   */
  closeLabel?: string
  /**
   * Can be controlled, but if not provided then it is handled by the Disclosure component
   * @default false
   */
  isOpen?: boolean
  children: React.ReactNode
  className?: string
}
const initialStyles = {
  maxHeight: 210,
  opacity: 1,
}
const minifiedStyles = {
  maxHeight: 0,
  opacity: 0,
}

export function Disclosure({
  isOpen: propsIsOpen = false,
  label,
  closeLabel,
  children,
  className,
}: DisclosureProps) {
  const [isOpen, setOpen] = useState(propsIsOpen)
  const transitions = useTransition(isOpen, null, {
    from: minifiedStyles,
    enter: initialStyles,
    leave: minifiedStyles,
    unique: true,
  })
  return (
    <div className={`${className} bootstrap4`}>
      <Button
        color="link"
        onClick={() => setOpen(!isOpen)}
        aria-expanded={isOpen}
        style={{ minHeight: 38 }}
      >
        {isOpen ? closeLabel || label : label}
      </Button>
      {transitions.map(({ item, props, key }) => {
        return (
          item && (
            <animated.div key={key} style={props} aria-hidden={!isOpen}>
              {children}
            </animated.div>
          )
        )
      })}
    </div>
  )
}
